import { IconLoader2 } from '@tabler/icons-react';

export default function Loader() {
  return (
    <div className="flex items-center justify-center min-h-screen w-full">
      <IconLoader2 className="h-12 w-12 animate-spin text-primary" />
    </div>
  );
}
